import {combineReducers} from 'redux';
import userSettingsReducer from './userSettingsReducer';
import settingsOptionsReducer from './settingsOptionsReducer';
import productReducer from './productReducer';
import currencyRatesReducer from './currencyRatesReducer';
import productRecommendationsReducer from './productRecommendationsReducer';
import filterSettingsReducer from './filterSettingsReducer';
import filterConfigReducer from './filterConfigReducer';
import galleryReducer from './galleryReducer';
import productFavouritesReducer from './productFavouritesReducer';
import plpSeoTextReducer from './plpSeoTextReducer';
import trackingReducer from './trackingReducer';
import staffOnlyReducer from './staffOnlyReducer';
import recentlyViewedProductsReducer from './recentlyViewedProductsReducer';
import heroReducer from './heroReducer';
import editorsPicksReducer from './editorsPicksReducer';
import artistsDiscoverReducer from './artistsDiscoverReducer';
import artistsPopularReducer from './artistsPopularReducer';
import basketReducer from './basketReducer';
import productAddToBundleReducer from './productAddToBundleReducer';
import featuredArtReducer from './featuredArtReducer';
import artistsFollowedReducer from './artistsFollowedReducer';

const rootReducer = combineReducers({
  userSettings: userSettingsReducer,
  settingsOptions: settingsOptionsReducer,
  filterSettings: filterSettingsReducer,
  filterConfig: filterConfigReducer,
  gallery: galleryReducer,
  product: productReducer,
  currencyRates: currencyRatesReducer,
  productRecommendations: productRecommendationsReducer,
  productFavourites: productFavouritesReducer,
  plpSeoText: plpSeoTextReducer,
  tracking: trackingReducer,
  staffOnly: staffOnlyReducer,
  recentlyViewedProducts: recentlyViewedProductsReducer,
  basket: basketReducer,
  hero: heroReducer,
  editorsPicks: editorsPicksReducer,
  artistsDiscover: artistsDiscoverReducer,
  artistsPopular: artistsPopularReducer,
  artistsFollowed: artistsFollowedReducer,
  productAddToBundle: productAddToBundleReducer,
  featuredArt: featuredArtReducer,
});

export default rootReducer;
